import React, { useState, useEffect, useMemo } from "react";
import { Col, Row, Select } from ".";
import { Fieldset } from "./Fieldset";
import { useTranslation } from "./hooks/useTranslation";
import { Input } from "./Input";
import { useFormContext } from "./Form";
import { Typeahead } from "./Typeahead";
export const updateProvinceList = (countryList, selectedCountry) => {
    const countryProvince = countryList.filter((c) => c.code === selectedCountry);
    return countryProvince.length === 1
        ? countryProvince[0].provinces.map(({ name, code }) => ({
            label: name,
            value: code,
        }))
        : [];
};
export const mapCountries = (country) => {
    return country.map(({ name, code }) => ({
        label: name,
        value: code,
    }));
};
export const AddressInput = ({ inputs, countryList, country, disabled, legend, fieldset = true, id, }) => {
    const t = useTranslation();
    const memoCountryList = useMemo(() => countryList, [countryList]);
    if (!fieldset) {
        return (React.createElement(AddressInputComponents, { inputs: inputs, countryList: memoCountryList, country: country, disabled: disabled, id: id }));
    }
    return (React.createElement(Fieldset, { legend: legend || t("Address"), id: id },
        React.createElement(AddressInputComponents, { inputs: inputs, countryList: memoCountryList, country: country, disabled: disabled })));
};
const AddressInputComponents = ({ inputs, countryList, country, disabled, id, }) => {
    const t = useTranslation();
    const { values } = useFormContext();
    const [selectedCountry, setSelectedCountry] = useState(inputs.country ? values.get(inputs.country.name) : null);
    const [provinceOptions, setProviceOptions] = useState([]);
    useEffect(() => {
        if (countryList) {
            setProviceOptions(updateProvinceList(countryList, selectedCountry));
        }
    }, [countryList, selectedCountry]);
    return (React.createElement(Row, { id: id },
        inputs.line1 && (React.createElement(Col, { xs: 12 },
            React.createElement(Input, { name: inputs.line1.name, label: t("Line 1"), disabled: disabled, uniqueId: id && `${id}__line-1`, required: inputs.line1.required ?? true }))),
        inputs.line2 && (React.createElement(Col, { xs: 12 },
            React.createElement(Input, { name: inputs.line2.name, label: t("Line 2"), disabled: disabled, uniqueId: id && `${id}__line-2`, required: inputs.line2.required ?? false }))),
        inputs.line3 && (React.createElement(Col, { xs: 12 },
            React.createElement(Input, { name: inputs.line3.name, label: t("Line 3"), disabled: disabled, uniqueId: id && `${id}__line-3`, required: inputs.line3.required ?? false }))),
        inputs.city && (React.createElement(Col, { xs: 12 },
            React.createElement(Input, { name: inputs.city.name, label: t("City/Town"), disabled: disabled, uniqueId: id && `${id}__city`, required: inputs.city.required ?? true }))),
        inputs.state && !countryList && (React.createElement(Col, { xs: 12 },
            React.createElement(Input, { name: inputs.state.name, label: t("Region/State"), disabled: disabled, uniqueId: id && `${id}__state`, required: inputs.state.required ?? false }))),
        inputs.postalCode && (React.createElement(Col, { xs: 12 },
            React.createElement(Input, { name: inputs.postalCode.name, label: t("Postal Code"), disabled: disabled, uniqueId: id && `${id}__postal-code`, required: inputs.postalCode.required ?? true }))),
        country && (React.createElement(Col, { xs: 12 },
            React.createElement(Typeahead, { label: t("Country"), ...country, disabled: disabled, uniqueId: id && `${id}__country` }))),
        countryList && inputs.country && (React.createElement(Col, { xs: 12 },
            React.createElement(Select, { name: inputs.country.name, label: t("Country"), uniqueId: id && `${id}__country`, options: mapCountries(countryList), onChange: (newCountry) => {
                    setSelectedCountry(newCountry);
                    if (inputs.province) {
                        values.set(inputs.province.name, undefined);
                    }
                }, required: inputs.country.required ?? true }))),
        countryList && inputs.province && (React.createElement(Col, { xs: 12 },
            React.createElement(Select, { name: inputs.province.name, label: t("Province"), uniqueId: id && `${id}__province`, options: provinceOptions, required: inputs.province.required ?? false })))));
};
